async function loadFonts(callback) {
  callback()
}

export default loadFonts